import React from 'react';

interface AlertBalloonProps {
	label: string | number | React.ReactNode;
	className?: string;
}

export function AlertBalloon({ label, className = '' }: AlertBalloonProps) {
	return (
		<div
			className={`inline-flex items-center size-5 justify-center px-2 py-1 text-xs bg-cherry-500 text-white rounded-full ${className}`}
		>
			{label}
		</div>
	);
}

export default AlertBalloon;
